import { render, staticRenderFns } from "./supplierUserList.vue?vue&type=template&id=437ba97a&"
import script from "./supplierUserList.vue?vue&type=script&lang=js&"
export * from "./supplierUserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports